import { useState } from 'react';

import Box from '~/common/components/Box';
import CloseButton from '~/common/components/Buttons/CloseButton';
import useBoltStatus from '~/common/hooks/useBoltStatus';
import useUrl from '~/common/hooks/useUrl';

export function TestLoanBanner() {
  const { obfuscatedLoanIdentifier } = useUrl();
  const {
    data: { isTestLoan },
  } = useBoltStatus();

  const sessionStorageKey = `testLoanBannerDismissed_${obfuscatedLoanIdentifier?.obfuscatedLoanRecordId}`;

  const [hasBannerBeenDismissed, setHasBannerBeenDismissed] = useState(
    () => sessionStorage.getItem(sessionStorageKey) === 'true',
  );

  function dismissBanner() {
    sessionStorage.setItem(sessionStorageKey, 'true');
    setHasBannerBeenDismissed(true);
  }

  if (!globalThis.isProd || hasBannerBeenDismissed || !isTestLoan) {
    return null;
  }

  return (
    <Box
      sx={{
        top: 0,
        left: 0,
        right: 0,
        width: '100%',
        backgroundColor: '#ff9800',
        color: '#000',
        textAlign: 'center',
        padding: '0.75rem 3rem',
        zIndex: 9999,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        fontWeight: 500,
      }}
    >
      <span>This is a production test loan</span>
      <CloseButton
        onClick={dismissBanner}
        aria-label="Dismiss test loan banner"
        sx={{
          position: 'absolute',
          right: '1rem',
          color: '#000',
        }}
      />
    </Box>
  );
}
